var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 200,
    viewBox: "0 0 156 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.4 30L88.1 4.89996L77.5 0.199951V92.1L98.6 71C102.6 67 109.1 67 113.2 71C117.2 75 117.2 81.5 113.2 85.6L77.5 121.3V169.6C77.5 169.6 77.5 169.7 77.5 170V170.1C77.4 172.9 77.3 188.1 77.2 199.2V199.5C77.3 199.4 77.4 199.4 77.5 199.4C77.6 199.4 77.7 199.3 77.8 199.3C123.6 180.1 145.9 151.4 150.6 117.3C154.2 91.5 154.9 62.4 155 46.6C155.1 39.4 150.9 32.9 144.4 30Z",
    fill: "#DF2226"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5 170V169.9C77.5 169.7 77.5 169.5 77.5 169.5V121.2L71.6 127.1L46.5 102C42.5 98 42.5 91.5 46.5 87.4C50.5 83.4 57 83.4 61.1 87.4L71.6 97.9L77.5 92V0L66.9 4.7L10.6 29.8C4.1 32.7 0 39.1 0 46.2C0.1 62 0.900002 91.1 4.4 116.9C9.1 151 31.4 179.7 77.2 198.9C77.3 198.9 77.4 199 77.5 199C77.6 199 77.7 199.1 77.8 199.1V198.8C77.7 188 77.6 172.8 77.5 170Z",
    fill: "#811719"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.b9411a5e4dfa3fd898ce162ca52a1489.svg";
export { ForwardRef as ReactComponent };